import { FC } from "react";
import { Box, Button, HStack, Stack, Text } from "@chakra-ui/react";

import { DebtText } from "./DebtText.tsx";
import { useAppModal } from "../../Modals";
import { Info2Icon } from "../../../icons";
import { DebtInfoModal } from "./DebtInfoModal.tsx";
import { useGetDebtStateQuery } from "../../../../api/debt";
import { isStringWithNumber, formatPriceWithoutZeros } from "../../../../utils";

export const PaymentsScheduleTodayDebt: FC = () => {
  const { showModal } = useAppModal();
  const { data } = useGetDebtStateQuery();

  const total = isStringWithNumber(data?.total) && Number(data?.total) > 0
    ? formatPriceWithoutZeros(Number(data?.total))
    : "";

  const overdue = isStringWithNumber(data?.overdue?.total) && Number(data?.overdue?.total) > 0
    ? formatPriceWithoutZeros(Number(data?.overdue?.total))
    : "";
  const principal = isStringWithNumber(data?.principal?.total)
    ? formatPriceWithoutZeros(Number(data?.principal?.total))
    : "";
  const interest = isStringWithNumber(data?.interest?.total)
    ? formatPriceWithoutZeros(Number(data?.interest?.total))
    : "";
  const penalty = isStringWithNumber(data?.penalty?.total)
    ? formatPriceWithoutZeros(Number(data?.penalty?.total))
    : "";

  const onClick = () => {
    showModal({
      content: onClose => <DebtInfoModal onClose={onClose} />,
    });
  };

  if (!total) {
    return null;
  }

  return (
    <Box px="17px" py="20px" borderRadius="16px" bg="white">
      <HStack justifyContent="space-between" alignItems="flex-start" mb="24px" mt={overdue ? "0px" : "1px"}>
        <Box>
          {overdue && (
            <Stack spacing="9px" mt="1px" mb="12px">
              <Text variant="red" fontSize="12px" lineHeight="12px">Просрочено</Text>

              <Text fontSize="24px" variant="red" fontFamily="Normalidad Medium Var">
                {overdue}
              </Text>
            </Stack>
          )}

          <Stack spacing={overdue ? "4px" : "7px"}>
            <Text fontSize={overdue ? "12px" : "16px"}>Задолженность на сегодня</Text>

            <Text fontSize={overdue ? "16px" : "22px"} variant="brand" fontFamily="Normalidad Medium Var">
              {total}
            </Text>
          </Stack>
        </Box>

        <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onClick}>
          <Info2Icon />
        </Button>
      </HStack>

      <Box borderTop="1px dashed" borderTopColor="gray.600" pt="8px" px="9px" mb="5px">
        <DebtText title="Основной долг" amount={principal} />
        <DebtText title="Проценты" amount={interest} />
        <DebtText title="Пени" amount={penalty} />
      </Box>
    </Box>
  );
};
